module.exports = __webpack_public_path__ + "media/images/pc/stores/fuji/fuji_concept_01-4524241ccfa7c0fe4b3bd1e106a037cc.jpg";